(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationDetailController', ApplicationDetailController);

    ApplicationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Application'];

    function ApplicationDetailController($scope, $rootScope, $stateParams, entity, Application) {
        var vm = this;

        vm.application = entity;

        var unsubscribe = $rootScope.$on('portalApp:applicationUpdate', function(event, result) {
            vm.application = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
